/* eslint-disable no-useless-escape */
export const Validations = {
  'FREE_TEXT_MAXLENGTH': 200,
  'REGEX_EMAIL' : /^(([\w-\s]+)|([\w-]+(?:\.[\w-]+)*)|([\w-\s]+)([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/,
  'REGEX_INTEGER': '^[0-9]*$',
  'REGEX_INTEGER_WITH_DECIMAL': '^[0-9]+(\.[0-9][0-9]?)?',
  'REGEX_NAME': '^[A-Za-z]+$',
  'REGEX_FREETEXT': '^[A-Za-z ]+$',
  'MAXLENGTH_CVV': 3,
  'MAXLENGTH_CARDNUMBER': 19,
  'REGEX_FILENAME': /^[a-zA-Z0-9-_ ]+$/,
  'TEXTAREA_MAXLENGTH': 500,
  'NUMBER_MAXLENGTH': 30,
  'MOBILE_MAXLENGTH': 10,
  'REGEX_INTEGER_WITH_ALPHABETS': '^[A-Za-z0-9 ]+$',
  'REGEX_IDENTIFICATION_NUMBER': '^[A-Za-z0-9]+$',
  'REGEX_ALPHANUMERIC_SPACES_HYPHEN': '^[A-Za-z0-9- ]+$',
  'REGEX_ALPHANUMERIC_SPACES_HYPHEN_DOT': '^[A-Za-z0-9-. ]+$',
  'REGEX_ZIPCODE_MAXLENGTH': 10,
};
